import { render, staticRenderFns } from "./ParcelSummaryDetails.vue?vue&type=template&id=730f8db5&"
import script from "./ParcelSummaryDetails.vue?vue&type=script&lang=js&"
export * from "./ParcelSummaryDetails.vue?vue&type=script&lang=js&"
import style0 from "./ParcelSummaryDetails.vue?vue&type=style&index=0&id=730f8db5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports